import { currentUser } from "../service/user"

const defaultPermission = {
    dashboard: {
        view: true
    },
    quiz: {
        create: true,
        view: true,
        edit: true,
        delete: true
    },
    question: {
        create: true,
        view: true,
        edit: true,
        delete: true
    },
    tag: {
        create: true,
        view: true,
        edit: true,
        delete: true
    },
    user: {
        create: true,
        view: true,
        edit: true,
        delete: true
    },
    order: {
        create: true,
        view: true,
        edit: true,
        delete: true
    },
    page: {
        create: true,
        view: true,
        edit: true,
        delete: true
    },
    blog: {
        create: true,
        view: true,
        edit: true,
        delete: true
    },
    log: {
        create: true,
        view: true,
        edit: true,
        delete: true
    },
    language: {
        create: true,
        view: true,
        edit: true,
        delete: true
    },
    setting: {
        create: true,
        view: true,
        edit: true,
        delete: true
    },
    coupon: {
        create: true,
        view: true,
        edit: true,
        delete: true
    },
    campaign: {
        create: true,
        view: true,
        edit: true,
        delete: true
    },
    school: {
        create: true,
        view: true,
        edit: true,
        delete: true
    },
    school_district: {
        create: true,
        view: true,
        edit: true,
        delete: true
    },
    front_page: {
        create: true,
        view: true,
        edit: true,
        delete: true
    },
    affiliate: {
        create: true,
        view: true,
        edit: true,
        delete: true
    }
}

const rolePermission = {
    super_admin: defaultPermission,

    admin: Object.assign({}, defaultPermission),

    member: Object.assign({}, defaultPermission),

    translator: {
        language: {
            create: true,
            view: true,
            edit: true,
            delete: true
        },
    }
}

export const can = (permission, moduleName) => {
    if (!currentUser()) {
        return false
    }

    const role = currentUser().role

    if (!rolePermission[role] || !rolePermission[role][moduleName]) {
        return false
    }

    return rolePermission[role][moduleName][permission]
}

export default {
    methods: {
        can: can
    }
}
